import { logoIcon } from "../assets";

export const companyInfo1 = {
        name: "Double Deuz",
        address: "Apac District",
        phone: "0392955101",
        email: "doubleduezapac@gmail.com",
        logo: logoIcon,
        website: "www.hotel.com",
        taxId: "4444",
        receiptFooter: "Thank you for your business! Please come again."
    };



export const companyInfo = {
        name: "Mogasoft",
        address: "Kampala District",
        phone: "0701243139",
        email: "moga@gmail.com@gmail.com",
        logo: logoIcon,
        website: "www.hotel.com",
        taxId: "4444",
        receiptFooter: "Thank you for your business! Please come again."
    };




export const foodTypes = [
    { id: 'ki', name: 'Kitchen Type' },
    { id: 'ot', name: 'Other Type' },
];

export const paymentModes = [
    { id: 'cash', name: 'Cash Payment' },
    { id: 'none', name: 'No Payment' },
    { id: 'bank', name: 'Bank Payment' },
    { id: 'mobile', name: 'Mobile Money' },
];

// Static data for dropdowns
export const banksData = [
    { id: 1, name: 'DBT' },
    { id: 2, name: 'DFCU' },
    { id: 3, name: 'Post Bank' },
    { id: 4, name: 'Stanbic Bank' },
    { id: 5, name: 'Standard Bank' },
    { id: 6, name: 'Centanry Bank' }
];

// Mockup data for selections
export const genderOptions = [
{ id: 'male', name: 'Male' },
{ id: 'female', name: 'Female' },
{ id: 'other', name: 'Other' }
];

export const dutyTypeOptions = [
{ id: 'full_time', name: 'Full Time' },
{ id: 'part_time', name: 'Part Time' },
{ id: 'contract', name: 'Contract' },
{ id: 'internship', name: 'Internship' }
];

export const payFrequencyOptions = [
{ id: 'monthly', name: 'Monthly' },
{ id: 'biweekly', name: 'Bi-Weekly' },
{ id: 'weekly', name: 'Weekly' },
{ id: 'daily', name: 'Daily' }
];


export const salaryTypeOptions = [
    { id: 'Monthly', name: 'Monthly' },
    { id: 'Weekly', name: 'Weekly' },
    { id: 'Bi-weekly', name: 'Bi-weekly' },
    { id: 'Daily', name: 'Daily' },
    { id: 'Hourly', name: 'Hourly' },
    { id: 'Commission', name: 'Commission' },
    { id: 'Bonus', name: 'Bonus' },
    { id: 'Contract', name: 'Contract' }
];


export const roomCleaningstatusData =[
    {id:1,name:"Pending"},
    {id:2,name:"Finished"},
    {id:4,name:"Cancelled"},
    {id:5,name:"Under Process"},

];

    export const developerInfo = {
        name: "mogasoft",
        webSite: "www.mogasoft.com",
        version: "1.0.0"
    };